import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AdminEventAPI } from "../../services/adminEvent.api";
import CreateEventModal from "./components/CreateEventModal";
import Toast from "../../components/Toast";

export default function EditEvent() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    async function fetchEvent() {
      try {
        const res = await AdminEventAPI.get(id);
        setEvent(res.data);
      } catch (err) {
        setToast({
          type: "error",
          message: "Failed to load event",
          timeout: 3000,
        });
      } finally {
        setLoading(false);
      }
    }

    fetchEvent();
  }, [id]);

  if (loading) {
    return <div className="page-loading">Loading event…</div>;
  }

  if (!event) {
    return <div className="page-error">Event not found</div>;
  }

  return (
    <>
      <CreateEventModal
        mode="edit"
        initialData={event}
        onClose={() => navigate(-1)}
        onCreated={() => {
          setToast({
            type: "success",
            message: "Event updated successfully",
            timeout: 2000,
          });
          navigate("/admin/dashboard");
        }}
      />

      {toast && (
        <Toast {...toast} onClose={() => setToast(null)} />
      )}
    </>
  );
}
